import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import vuetify from "../../../service/useVuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    mini: { type: Boolean },
    loading: { type: Boolean },
    logoSmall: null,
    logoSmallWidth: { default: "40px" },
    logoSmallHeight: { default: "40px" },
    logoBig: null,
    logoBigWidth: { default: "120px" },
    logoBigHeight: { default: "44px" },
    logoMarginSM: { default: "margin: 12px 4px" },
    logoMarginMD: { default: "margin: 12px 8px" },
    logoMarginLG: { default: "margin: 10px 56px 21px 38px" },
    logoMarginXL: { default: "margin: 10px 76px 21px 59px" },
    altLogoSmall: null,
    altLogoBig: null
  },
  setup(__props: any) {

const errorDownloadingBigImage = ref(false);
const errorDownloadingSmallImage = ref(false);



return { __sfc: true,errorDownloadingBigImage, errorDownloadingSmallImage, vuetify }
}

})